import { useMemo } from "react";
import { useSelector } from "react-redux";

export default function useAssistantDoctorId() {
  const doctorIdFromAuth = useSelector(
    (state) => state.assistantManagement?.auth?.doctorId || null
  );

  return useMemo(() => {
    if (doctorIdFromAuth) return doctorIdFromAuth;

    if (typeof window === "undefined") return null;

    return (
      localStorage.getItem("assistantDoctorId") ||
      localStorage.getItem("doctorId") ||
      null
    );
  }, [doctorIdFromAuth]);
}
